import { css } from 'lit-element';

export class HeaderStyles {
    static get styles() {
        return css`
            h1,
            h2,
            h3 {
                margin-block-start: 0.6em !important;
                margin-block-end: 0;
                margin: 0;
                text-transform: capitalize;
                width: 90%;
            }

            /* todo play with this, fix up colors*/
            h1 {
                margin: 0 1em 0.6em 0;
                font-weight: 400;
                position: relative;
                font-size: 1.5rem;
                line-height: 30px;
                /*
                color: white;
                background: #355681;
                */
                color: var(--app-primary-color, black);
                /* background: rgba(53, 86, 129, 0.8); */
                border: 1px solid #fff;
                padding: 6px 2px;

                /* border-radius: 8px; */
                /* box-shadow: inset 0 0 5px rgba(53, 86, 129, 0.5); */
                box-shadow: rgba(33, 35, 38, 0.1) 0px 10px 10px -10px;
                font-family: 'Montserrat', sans-serif;
            }
            h1 .normal-case {
                text-transform: none;
            }

            h2 {
                margin: 0 0 0.5em 0;
                font-weight: 400;
                position: relative;
                text-shadow: 0 -1px 1px rgba(0, 0, 0, 0.4);
                font-size: 1.3rem;
                line-height: 28px;
                padding: 4px;
                color: #355681;
                font-family: 'Lato', sans-serif;
                border-bottom: 1px solid rgba(53, 86, 129, 0.3);
            }

            h3 {
                margin: 0.5em 0 0.5em 0;
                font-weight: 600;
                font-family: 'Titillium Web', sans-serif;
                position: relative;
                font-size: 18px;
                line-height: 20px;
                color: #788699;
                font-family: 'Lato', sans-serif;
            }

            h4 {
                margin: 0.5em 0 0.3em 0;
                font-family: 'Lato', sans-serif;
                position: relative;
                font-size: 16px;
                line-height: 20px;
                color: #788699;
            }
        `;
    }
}
